<template>
	<div class="search-num">
		<div class="header-wrap">
			<div class="header-box">
				<img src="../../assets/xigongda/logo.png" alt=""><i></i><span>新生学号查询</span>
			</div>
		</div>
		<div class="search-num-content">
			<div class="from">
				<h2><i class="el-icon-warning"></i>本页面，仅供<span class="year">{{ year }}</span>级本科新生学号查询，考生凭录取通知书上条形码下方14位数字进行查询</h2>
				<div>
					<span>请输入考生号：</span><input class="form-control" type="text" v-model="num" placeholder="14位考生号"><button
						type="button" class="search-btn" @click="queryDetail()">查询</button>
				</div>
			</div>
			<div class="searched" v-if="searchd">
				<h3>考生信息</h3>
				<p class="ksh">
					<span>考生号：</span><span class="search-content">{{ form.ksh }}</span>
				</p>
				<p class="xh">
					<span>学号：</span><span class="search-content">{{ form.xh }}</span>
				</p>
				<p class="lqxy" style="white-space: nowrap;">
					<span style="width: 110px;">录取大类/学院：</span><span class="search-content">{{ form.orgName }}</span>
				</p>
				<p class="sfzh" style="white-space: nowrap;">
					<span>录取专业：</span><span class="search-content">{{ form.sfzh }}</span>
				</p>
				<p class="xm">
					<span>姓名：</span><span class="search-content">{{ form.xm }}</span>
				</p>
			</div>
			<div class="nosearch" v-if="nosearch">
				<div class="left"><i class="el-icon-warning"></i></div>
				<div class="right">
					<p>抱歉，没有查询到您的记录可能的原因为：</p>
					<p>1.考生号码输入错误</p>
					<p>2.数据库中保存的是考生号码有误，请到教务处进行查询。</p>
				</div>
			</div>
		</div>

		<div class="search-num-footer">
			<div class="search-num-footer-left">
				<ul class="newFooter">
					<li>
						<p>信息化建设与管理处用户服务电话：029-88491717</p>
						<p>门户技术服务：029-88493092</p>
					</li>
					<li>
						<p>
							<span>友谊校区地址：西安市友谊西路127号</span>
							<span>邮编：710072</span>
						</p>
						<p>
							<span>长安校区地址：西安市长安区东祥路1号</span>
							<span>邮编：710129 </span>
						</p>
					</li>
					<li>
						<p>版权所有 © 西北工业大学 ICP备案号：陕ICP备05010979</p>
					</li>
				</ul>
			</div>
			<div class="search-num-footer-right">
				<img src="../../assets/xigongda/ewm.png" alt="">
				<p>常用二维码</p>
			</div>
		</div>
	</div>
</template>

<script>
import { getPersonalDetail } from '@/api/xigongda.js';
export default {
	name: 'newSearchNum',
	data() {
		return {
			searchd: false,
			nosearch: false,
			num: '',
			form: {
				id: '',
				extras: '',
				xh: '',
				orgId: '',
				orgName: '',
				xm: '',
				ksh: '',
				sfzh: ''
			},
			year: ''
		}
	},
	mounted(){
		this.getCurrentTime()
	},
	methods: {
		// 获取当前时间
		getCurrentTime(){
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let time = yy + '/' +mm
			console.log(time)
			if(mm >= 7){
				this.year = yy
			}else{
				this.year = yy - 1
			}
		},

		queryDetail() {
			this.handPersonalDetail()
		},
		handPersonalDetail() {
			let data = {
				sfzh: this.num
			}
			getPersonalDetail(data).then(res => {
				console.log(res)
				if (res.data.length !== 0) {
					this.form = res.data[0];
					this.searchd = true;
					this.nosearch = false;
				} else {
					this.searchd = false;
					this.nosearch = true;
				}
			})
		}
	},
}
</script>

<style lang="scss" scoped>
.search-num {
	width: 100%;

	// margin-left: -50px;
	.header-wrap {
		width: 100%;
		height: 110px;
		background: #133b71;
		display: flex;
		align-items: center;
		padding-left: 130px;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;

		.header-box {
			height: 100%;
			display: flex;
			align-items: center;
			color: #fff;

			i {
				width: 6px;
				height: 6px;
				border-radius: 50%;
				background: #a1b1c6;
				margin: 0 20px;
			}

			span {
				font-size: 26px;
				color: #a1b1c6;
			}
		}
	}

	&-content {
		width: 87.5%;
		min-height: 600px;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0px 0px 8px #ddd;
		margin: 20px auto;
		padding: 50px;
		text-align: center;
		margin-bottom: 80px;
		margin-top: 155px;

		.from {
			margin-bottom: 60px;

			>h2 {
				margin-bottom: 60px;

				i {
					color: #169cdb;
				}
			}

			>div {
				font-size: 16px;

				.form-control {
					width: 500px;
					height: 45px;
					border-radius: 45px;
					border: 1px solid #ddd;
					padding: 0 10px;
					margin-right: 15px;
				}

				.search-btn {
					width: 110px;
					height: 45px;
					border-radius: 45px;
					background: #2267b1;
					color: #fff;
					border: none;
					font-size: 16px;
				}
			}
		}
	}

	.searched {
		width: 310px;
		margin: 0 auto;
		line-height: 50px;

		h3 {
			font-size: 26px;
		}
	}

	.nosearch {
		width: 650px;
		margin: 0 auto;
		display: flex;

		.left {
			width: 20%;
			font-size: 50px;
			color: #FF6A6A;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.right {
			text-align: left;
			line-height: 32px;
			font-size: 16px;
		}
	}

	&-footer {
		width: 100%;
		padding: 30px 130px;
		background: #133b71;
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		line-height: 30px;

		&-left {
			>ul {
				li {
					display: flex;

					p {
						margin-right: 15px;

						span {
							margin-right: 15px;
						}
					}
				}
			}
		}

		&-right {
			text-align: right;
		}
	}
}

input {
	outline: none;
}

input[type=text]:focus {
	box-shadow: none;
	border: none;
}

@media screen and (max-width: 1280px) {
	.search-num {
		width: 100%;

		// margin-left: -50px;
		.header-wrap {
			width: 100%;
			height: 60px;
			background: #133b71;
			display: flex;
			align-items: center;
			padding-left: 15px;
			padding-right: 15px;
			position: fixed;
			top: 0;
			left: 0;
			right: 0;

			.header-box {
				height: 100%;
				display: flex;
				align-items: center;
				color: #fff;
				img{
					width: 175px;
				}
				i {
					width: 6px;
					height: 6px;
					border-radius: 50%;
					background: #a1b1c6;
					margin: 0 10px;
				}

				span {
					font-size: 14px;
					color: #a1b1c6;
				}
			}
		}

		&-content {
			width: 87.5%;
			min-height: 480px;
			background: #fff;
			border-radius: 8px;
			box-shadow: 0px 0px 8px #ddd;
			margin: 10px auto;
			padding: 80px 20px 20px;
			text-align: center;
			margin-bottom: 50px;
			margin-top: 80px;

			.from {
				margin-bottom: 60px;

				>h2 {
					margin-bottom: 30px;
					font-size: 14px;

					i {
						color: #169cdb;
					}
				}

				>div {
					font-size: 12px;
					display: flex;
					flex-direction: column;
					justify-content: flex-start;
					align-items: flex-start;

					.form-control {
						width: 100%;
						height: 28px;
						border-radius: 28px;
						border: 1px solid #ddd;
						padding: 0 10px;
						margin-right: 0;
						margin-top: 15px;
						margin-bottom: 15px;
					}

					.search-btn {
						width: 110px;
						height: 28px;
						border-radius: 28px;
						background: #2267b1;
						color: #fff;
						border: none;
						font-size: 12px;
						margin: 0 auto;
						margin-top: 50px;
					}
				}
			}
		}

		.searched {
			width: 100%;
			margin: 0 auto;
			line-height: 30px;

			h3 {
				font-size: 16px;
			}
		}

		.nosearch {
			width: 100%;
			margin: 0 auto;
			display: flex;

			.left {
				width: 20%;
				font-size: 30px;
				color: #FF6A6A;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.right {
				text-align: left;
				line-height: 20px;
				font-size: 12px;
			}
		}

		&-footer {
			width: 100%;
			padding: 15px;
			background: #133b71;
			color: #fff;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 12px;
			line-height: 26px;

			&-left {
				>ul {
					li {
						display: flex;
						flex-direction: column;

						p {
							margin-right: 15px;
							display: flex;
							flex-direction: column;
							span {
								margin-right: 15px;
							}
						}
					}
				}
			}

			&-right {
				text-align: right;
				white-space: nowrap;
				img{
					width: 40px;
				}
			}
		}
	}

	input {
		outline: none;
	}

	input[type=text]:focus {
		box-shadow: none;
		border: none;
	}
}
</style>
